module.exports = __webpack_public_path__ + "static/media/bmw_zertifikat_2013.d0df0399.jpg";